<template>
	<Skeleton :paragraph="{ rows: 4 }" :title="false" :loading="loading">
		<Form :model="formState" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" :colon="false">
			<FormItem>
				<template #label>
					<Tooltip placement="topLeft" color="black">
						<template #title>{{ $t('settings.vrsSettingsForm.paasEnabledHint') }}</template>
						<QuestionCircleOutlined /> {{ $t('settings.vrsSettingsForm.paasEnabled') }}
					</Tooltip>
				</template>
				<LabeledSwitch v-model="paasEnabled" @change="onUpdateField('paasEnabled', $event)" />
			</FormItem>
			<FormItem :label="$t('settings.vrsSettingsForm.paasTaskHour')" v-bind="validateInfos.paasTaskHour">
				<InputDecimal
					v-model="formState.paasTaskHour"
					range="all"
					:minValue="0"
					:maxValue="23"
					:allowPoint="false"
				/>
			</FormItem>
			<FormButtonsItem>
				<Button type="primary" @click.prevent="onSubmit" :loading="isSubmitting">
					{{ $t('settings.vrsSettingsForm.buttonLabel') }}
				</Button>
				<Button type="default" @click.prevent="onAddFromSettings" :loading="isSubmittingAddFromSettings">
					{{ $t('settings.vrsSettingsForm.addFromSettingsButtonLabel') }}
				</Button>
			</FormButtonsItem>
		</Form>
	</Skeleton>
</template>

<script>
import { reactive, nextTick, toRaw, watch, ref } from 'vue';
import { Button, Skeleton, Form, FormItem, message, Tooltip } from 'ant-design-vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

import Api from '@/api/Api';
import ApiPaas from '@/api/ApiPaas';
import Utils from '@/api/Utils';
import Validators from '@/api/Validators';

import InputDecimal from '@/components/common/InputDecimal';
import LabeledSwitch from '@/components/common/LabeledSwitch.vue';
import FormButtonsItem from '@/components/common/FormButtonsItem.vue';

import { useVRSSettingsPost } from '@/components/settings/useVRSSettingsPost.js';
import { showErrorMessage } from '@/components/common/errorMessage';

import { useProvideInjectFormChangedStatuses } from '@/utils/useProvideInject';


export default {
	components: {
		Button, Skeleton, Form, FormItem, InputDecimal,
		LabeledSwitch, FormButtonsItem, Tooltip, QuestionCircleOutlined,
	},

	props: ['loading', 'settings', 'onUpdateField'],

	setup(props) {
		const formState = reactive({
			paasTaskHour: null,
		});

		const paasEnabled = ref(false);

		const { validate, validateInfos } = Validators.useVRSSettingsPaasSettingsFormRules(formState);
		const { injectValue } = useProvideInjectFormChangedStatuses;
		const formChangedStatuses = injectValue();
		const { enableWatch, pauseWatch, resetChangedState } = Validators.useWatchFormChanges(formState, formChangedStatuses, 'PaasSettingsForm');
		const { isSubmitting, onSubmit } = useVRSSettingsPost(Api.vrsSettingsPost, formState, validate, toRaw, resetChangedState);

		const isSubmittingAddFromSettings = ref(false);
		const onAddFromSettings = () => {
			isSubmittingAddFromSettings.value = true;
			ApiPaas.paasTaskAddFromSettings(response => {
				isSubmittingAddFromSettings.value = false;
				if (response.status === 'ok') {
					message.success(response.message);
				} else {
					showErrorMessage(response.errors);
				}
			});
		};

		watch(
			() => props.settings,
			value => {
				pauseWatch();
				Utils.updateObject(formState, value);
				paasEnabled.value = value.paasEnabled;
				nextTick(enableWatch);
			},
		);

		return {
			formState,
			validateInfos,
			isSubmitting,
			isSubmittingAddFromSettings,
			onSubmit,
			paasEnabled,
			onAddFromSettings,
		};
	},
};
</script> 